import React from "react";
import { useTranslation } from "react-i18next";
import "./Description.css";

const Description = () => {
  const { t } = useTranslation();

  return (
    <section className="about-description">
      <h3><strong>{t("aboutUs.description.title")}</strong></h3>
      <p>{t("aboutUs.description.p1")}</p>
      <p>{t("aboutUs.description.p2")}</p>
      <p>{t("aboutUs.description.p3")}</p>
      <p>{t("aboutUs.description.p4")}</p>
      <p>{t("aboutUs.description.p5")}</p>
      <p>{t("aboutUs.description.p6")}</p>
      <p><em>{t("aboutUs.description.p7")}</em></p>
    </section>
  );
};

export default Description;
